import React, { useMemo, useState, useEffect, useRef, useCallback } from "react";
import cn from "classnames";
import { urlSearchParams } from "@utility/utills";
import { ReactComponent as BackChevron } from "@assets/images/backChevron.svg";
import { ReactComponent as EipsEdit } from "@assets/images/eipsEdit.svg";
import { ReactComponent as EipsRedo } from "@assets/images/eipsRedo.svg";
import { APP_CONFIG } from "@constants";
import Keyboard from "@components/KeyboardV2";
import FullWithModal from "@components/common/Modal/FullWidthModal";
import { ReactComponent as Cross } from "@assets/images/cross.svg";
import styles from "./EmployeeInitiatedPaymentScreen.module.scss";
import { CUSTOM_MESSAGES, LABEL } from "../../../veriables";
import { ReactComponent as Delete } from "@assets/images/delete.svg";
import { TouchableDiv, TouchableButton } from '@components/common/Touchable'
import Modal from '@components/common/Modal';
import EventEmitter from '@utility/eventSubscribers';

const EmployeeInitiatedPaymentScreen = (props) => {
  // props destructuring
  const {
    seat,
    setSeat,
    previousScreen,
    setPaymentType,
    // setNotification,//
    PayByCardBtn,
    handleCreditCardDeleteBalance,
    setPayModeType,
    payModeType,
    handleGiftCardPayment,
    handleCashClearBalance,
    // setInfoDeletion,
    infoDeletion,
    handleCashCompletePayment,
    authInfo,
    toggleOtherPaymentOption,
    setErrorPopUp,
    creditCardAmount,
    setCreditCardAmount,
    isAmountEdit,
    setIsAmountEdit,
    currenySymbol,
    serverAppTheme,
    deviceInfo,
    tipInfo,
    hasAutoGratuity,
    isAutoGratuityPresent,
    isDriveThru,
    handlePayAtCounterPayment,
    setViewDetailsOpen,
    giftCardDeleteBalance,
    userInfo,
    tableData,
    speedOrderMode,
    isCallCenter,
    isTogo,
    setSendOrderConfirmation,
    isCounter,
    isTipOnlyEnabled,
    handleBackForTipOnly,
    getRoundingPayment,
  } = props;

  // state Management
  const [inputs, setInputs] = useState({ editCreditCardAmount: "" });
  const [inputName, setInputName] = useState();
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;
  const creditCardAmountRef = useRef(creditCardAmount);
  creditCardAmountRef.current = creditCardAmount;
  const [isGiftCardZero, setIsGiftCardZero] = useState(false);
  const [isPayAtCounterPopUp, setIsPayAtCounterPopUp] = useState(false);
  const [currentGiftCardPage, setCurrentGiftCardPage] = useState(0);
  // const
  const CREDIT_CARD = LABEL().CREDIT_CARD_PAY;
  const GIFT_CARD = LABEL().GIFT_CARD_PAY;
  const CASH = LABEL().CASH_PAY;
  const DEFAULT = LABEL().DEFAULT_PAY;

  const amountDue = Number(seat?.paymentCheck?.paymentAmount || 0);
  const isZeroAmountDue = amountDue === 0 && !payModeType;
  const isRoundingEnable = authInfo?.cashRoundingInfo;

  const paymentDetails = [
    {
      name: LABEL().RECEIPT_SUBTOTAL,
      key: "Subtotal",
      price: seat?.paymentCheck?.subTotalAmount,
      show: () => true,
    },
    { name: LABEL().RECEIPT_TAX, key: "Tax", price: seat?.paymentCheck?.taxAmount, show: () => true },
    {
      name: LABEL().RECEIPT_DISCOUNT,
      key: "Discount",
      price: seat?.paymentCheck?.discountAmount,
      show: () => true
    },
    { name: LABEL().RECEIPT_TOTAL, key: "Total", price: seat?.paymentCheck?.totalAmount, show: () => true },
    { name: LABEL().RECEIPT_TIP, key: "Tip", price: seat?.paymentCheck?.tipAmount, show: () => (isTogo || isCallCenter) ? false : true },
    { name: LABEL().RECEIPT_SERVICE_CHARGE, key: "ServiceCharge", price: seat?.paymentCheck?.serviceChargeAmount, show: () => seat?.paymentCheck?.serviceChargeAmount > 0 },
    { name: LABEL().EPS_ROUNDING, key: "rounding", price: seat?.paymentCheck?.cash?.roundingAmount, show: () => (seat?.paymentCheck?.cash?.roundingAmount ?? 0) !== 0 },
  ];
  useEffect(() => {
    setCreditCardAmount(String(Number(seat?.paymentCheck?.paymentAmount)?.toFixed(2)));
  }, [seat?.paymentCheck?.paymentAmount]);

  const getGiftCard = () => {
    if (seat?.paymentCheck?.giftCard) {
      return seat.paymentCheck.giftCard;
    }
    if (seat?.paymentCheck?.giftCards && seat.paymentCheck.giftCards.length > 0) {
      return seat.paymentCheck.giftCards[0];
    }
    return null;
  };

  const getAllGiftCards = () => {
    if (seat?.paymentCheck?.giftCard) {
      return [seat.paymentCheck.giftCard];
    }
    if (seat?.paymentCheck?.giftCards && seat.paymentCheck.giftCards.length > 0) {
      return seat.paymentCheck.giftCards;
    }
    return [];
  };

  const formatRedactedCardNumber = (cardNumber) => {
    if (!cardNumber) return "";
    const cardStr = String(cardNumber);
    const lastFour = cardStr.length <= 4 ? cardStr : cardStr.slice(-4);
    return `xxx${lastFour}`;
  };

  const getCurrentPageGiftCards = () => {
    const allCards = getAllGiftCards();
    const startIndex = currentGiftCardPage * 2;
    return allCards.slice(startIndex, startIndex + 2);
  };

  const handleDeleteAllGiftCards = async () => {
    const allCards = getAllGiftCards();
    if (allCards.length === 0) return;

    if (!giftCardDeleteBalance || !userInfo || !deviceInfo) {
      console.error("Missing required dependencies for gift card deletion");
      return;
    }

    try {
      let currentPaymentCheck = seat?.paymentCheck;
      let currentPaymentChecks = seat?.paymentChecks;
      let lastResponse = null;

      for (const card of allCards) {
        const response = await giftCardDeleteBalance({
          deviceId: deviceInfo.deviceId,
          employeeId: Number(userInfo.id),
          employeeCard: userInfo?.employeeCard,
          checkHeaderId: tableData?.id,
          storeId: deviceInfo.storeId,
          giftCard: {
            ticketId: card.ticketId || 0,
            balanceAmount: card.balanceAmount || 0,
            paymentAmount: card.paymentAmount || 0,
            method: card.method || "type",
            accountNumber: card.accountNumber || card.displayAccountNumber || card.cardNumber,
            securityCode: card.securityCode || "",
            displayAccountNumber: card.displayAccountNumber || card.accountNumber,
            isActivated: card.isActivated || false,
            suppressTip: card.suppressTip || false,
          },
          paymentCheck: currentPaymentCheck,
          paymentChecks: currentPaymentChecks,
        });

        if (response?.paymentCheck) {
          currentPaymentCheck = response.paymentCheck;
        }
        if (response?.paymentChecks) {
          currentPaymentChecks = response.paymentChecks;
        }
        lastResponse = response;
      }

      if (lastResponse && setSeat) {
        setSeat({
          ...seat,
          paymentCheck: lastResponse.paymentCheck,
          paymentChecks: lastResponse.paymentChecks,
        });
      }

      setPayModeType(DEFAULT);
      setCurrentGiftCardPage(0);
    } catch (err) {
      console.error("Error deleting gift cards:", err);
      setErrorPopUp({
        res: err?.message || "Failed to delete gift cards",
      });
    }
  };

  useEffect(() => {
    if (getCurrentPageGiftCards().length === 0 && currentGiftCardPage > 0) {
      setCurrentGiftCardPage(currentGiftCardPage - 1);
    }
  }, [getAllGiftCards().length, currentGiftCardPage]);

  useEffect(() => {
    const allCards = getAllGiftCards();
    const totalGiftCardAmount = allCards.reduce((sum, card) => sum + (Number(card?.paymentAmount) || 0), 0);

    if (allCards.length > 0 && totalGiftCardAmount <= 0) {
      setIsGiftCardZero(true);
    } else {
      setIsGiftCardZero(false);
    }
  }, [seat?.paymentCheck?.giftCard, seat?.paymentCheck?.giftCards]);

  useEffect(() => {
    const allCards = getAllGiftCards();

    if (allCards.length > 0) {
      setPayModeType(DEFAULT);
    } else if (seat?.paymentCheck?.creditCard) {
      setPayModeType(CREDIT_CARD);
    } else if (seat?.paymentCheck?.cash) {
      setPayModeType(CASH);
    } else {
      setPayModeType(DEFAULT);
    }
  }, [seat?.paymentCheck])

  const paymentModes = [
    { name: LABEL().EPS_CREDIT_CARD, key: CREDIT_CARD, show: () => !isTogo && !isCallCenter && deviceInfo?.deviceGroup?.paymentTypes?.creditCard },
    {
      name: LABEL().EPS_GIFT_CARD,
      key: GIFT_CARD,
      show: () => !isTogo && !isCallCenter && authInfo?.loyaltyInfo?.supportsGiftCardPayment,
    },
    { name: LABEL().EPS_CASH, key: CASH, show: () => !isTogo && !isCallCenter && deviceInfo?.deviceGroup?.paymentTypes?.cash },
  ];

  const visiblePaymentModes = paymentModes.filter(item => item.show());
  const colClass =
    visiblePaymentModes.length === 3 ? "col-4" :
      visiblePaymentModes.length === 2 ? "col-6" :
        "col-12";

  const isPayAtCounter = deviceInfo?.deviceGroup?.paymentTypes?.payAtCounter;
  // React Hooks
  const AmountPopUpStyle = useMemo(() => {
    const amountPopUp = {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      width: "100%",
      pointerEvents: "auto",
      backgroundColor: serverAppTheme?.popUp_bg,
      backgroundClip: "padding-box",
      height: "100%",
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
    };

    return { amountPopUp };
  }, [serverAppTheme]);

  const hanldeRoundingPayment = () => {
    const cashamount = {
      changeAmount: 0,
      collectedAmount: 0,
      paymentAmount:  Number(creditCardAmount),
      roundingAmount: 0
    };

    let payload = {
      storeId: deviceInfo?.storeId,
      deviceId: deviceInfo?.deviceId,
      employeeId: userInfo?.id,
      employeeCard: userInfo?.employeeCard,
      checkHeaderId: tableData.id,
      cash: cashamount,
      paymentCheck: seat?.paymentCheck,
      paymentChecks: seat?.paymentChecks,
    };
    getRoundingPayment(payload)
      .then(res => {
        setSeat({
          ...seat,
          paymentCheck: res?.paymentCheck,
          paymentChecks: res?.paymentChecks,
        });
        setCreditCardAmount(
          String(Number(res?.paymentCheck?.cash?.paymentAmount || 0).toFixed(2)) ||
          '0'
        );
        setPaymentType(16);
        props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${res?.paymentCheck?.id || seat.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams("ticketSplitTypeId")}&splitValue=${urlSearchParams("splitValue")}&screenType=16&type=${urlSearchParams("type")}`, { replace: true });
      }).catch(err => {
        setErrorPopUp({
          res: err.message,
        });
      });
  }

  // Methods
  const disablePaymentModes = (key) => {
    const data = seat?.paymentCheck;
    return (data?.cash || data?.creditCard) && key !== payModeType
  };

  const handleAllPayment = (payType) => {
    setPayModeType((prev) => (prev === payType ? DEFAULT : payType));

    if (payType === GIFT_CARD) {
      setPaymentType(12);
      props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${seat.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams("ticketSplitTypeId")}&splitValue=${urlSearchParams("splitValue")}&screenType=12&type=giftCardPay`, { replace: true });
      return;
    }

    if (payType === CASH && !seat?.paymentCheck?.cash) {
      if (isRoundingEnable) {
        hanldeRoundingPayment();
      } else {
        setPaymentType(16);
        props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${seat.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams("ticketSplitTypeId")}&splitValue=${urlSearchParams("splitValue")}&screenType=16&type=${urlSearchParams("type")}`, { replace: true });
      }
    } else if (payType === CASH && seat?.paymentCheck?.cash) {
      setPayModeType(payType);
    } else if (payType === CREDIT_CARD && seat?.paymentCheck?.creditCard) {
      setPayModeType(payType);
    }
  };

  const handlePayment = () => {
    const paymentAmount = seat?.paymentCheck?.paymentAmount;
    const giftcardReceiptEnabled = props?.seat?.paymentCheck?.cards?.filter(card => card?.type !== 1)?.length > 0;
    window.sessionStorage.setItem(
      'giftCardpayment',
      giftcardReceiptEnabled
    );

    if (payModeType === CREDIT_CARD) {
      const amount = creditCardAmount && Number(creditCardAmount);
      if (amount <= 0 || amount > paymentAmount) {
        const message =
          amount <= 0
            ? "Entered Amount must be greater than 0"
            : `Entered Amount must be less than or equal to payment Amount:${paymentAmount}`;
        setErrorPopUp({
          res: message,
        });
      } else {
        PayByCardBtn(
          creditCardAmount ||
          seat?.paymentCheck?.creditCard?.paymentAmount?.toFixed(2),
        );
      }
    }
    if (payModeType === GIFT_CARD) {
      if (!isGiftCardZero) {
        handleGiftCardPayment();
      }
    }
    if (payModeType === CASH) {
      handleCashCompletePayment();
    }
  };

  const handleBackButton = async () => {
    const allCards = getAllGiftCards();
    if (allCards.length > 0) {
      await handleDeleteAllGiftCards();
    } else if (seat?.paymentCheck?.cash) {
      handleCashClearBalance(infoDeletion?.type, CASH);
    } else if (seat?.paymentCheck?.creditCard) {
      handleCreditCardDeleteBalance(infoDeletion?.type, CREDIT_CARD);
    } if (
      (urlSearchParams("screenType") === "31" || urlSearchParams("screenType") === "32") &&
      urlSearchParams("type") === "payType"
    ) {
      if (deviceInfo !== null && deviceInfo?.deviceGroup !== null && deviceInfo?.deviceGroup?.serverAppSettings?.powerPaymentOnly) {
        if (hasAutoGratuity) {
          if (isAutoGratuityPresent) {
            setPaymentType(4);
            props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${seat?.id}?ticketSplitTypeId=${urlSearchParams("ticketSplitTypeId")}&splitValue=${urlSearchParams("splitValue")}&screenType=4&type=${urlSearchParams("type")}`, { replace: true });
          } else {
            setPaymentType(28);
            props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${seat?.id}?ticketSplitTypeId=${urlSearchParams("ticketSplitTypeId")}&splitValue=${urlSearchParams("splitValue")}&screenType=28&type=${urlSearchParams("type")}`, { replace: true });
          }
        } else if (tipInfo) {
          setPaymentType(4);
          props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${seat?.id}?ticketSplitTypeId=${urlSearchParams("ticketSplitTypeId")}&splitValue=${urlSearchParams("splitValue")}&screenType=4&type=${urlSearchParams("type")}`, { replace: true });
        } else {
          setPaymentType(28);
          props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${seat?.id}?ticketSplitTypeId=${urlSearchParams("ticketSplitTypeId")}&splitValue=${urlSearchParams("splitValue")}&screenType=28&type=${urlSearchParams("type")}`, { replace: true });
        }
      } else {
        if (isDriveThru || isCounter || speedOrderMode || isCallCenter || isTogo) {
          props.navigate(`${APP_CONFIG.BASE_URL}/orders`, { replace: true })
        }
        else {
          setPaymentType(31);
          props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${seat?.id}?ticketSplitTypeId=${urlSearchParams("ticketSplitTypeId")}&splitValue=${urlSearchParams("splitValue")}&screenType=31&type=${urlSearchParams("type")}`, { replace: true });
        }
      }
    } else {
      if (deviceInfo !== null && deviceInfo?.deviceGroup !== null && deviceInfo?.deviceGroup?.serverAppSettings?.powerPaymentOnly) {
        if (tipInfo) {
          setPaymentType(4);
          props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${seat?.id}?ticketSplitTypeId=${urlSearchParams("ticketSplitTypeId")}&splitValue=${urlSearchParams("splitValue")}&screenType=4&type=${urlSearchParams("type")}`, { replace: true });
        } else {
          setPaymentType(28);
          props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${seat?.id}?ticketSplitTypeId=${urlSearchParams("ticketSplitTypeId")}&splitValue=${urlSearchParams("splitValue")}&screenType=28&type=${urlSearchParams("type")}`, { replace: true });
        }
      } else {
        if (isDriveThru || isCounter || speedOrderMode || isCallCenter || isTogo) {
          props.navigate(`${APP_CONFIG.BASE_URL}/orders`, { replace: true })
        } else {
          setPaymentType(previousScreen);
          props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${seat?.id}?ticketSplitTypeId=${urlSearchParams("ticketSplitTypeId")}&splitValue=${urlSearchParams("splitValue")}&screenType=${previousScreen}&type=${urlSearchParams("type")}`, { replace: true });
        }
      }
    }
    if (!deviceInfo?.deviceGroup?.serverAppSettings?.powerPaymentOnly &&
      window.ReactNativeWebView &&
      previousScreen === 1
    ) {
      EventEmitter.changeOrientation({
        orientation: "landscape",
      });
    }
  };

  const closeKeyboard = useCallback(() => {
    const currentInputs = inputsRef.current;
    const currentAmount = creditCardAmountRef.current;
    if (!currentInputs[inputName] || currentInputs[inputName].trim() === "") {
      setErrorPopUp({ res: 'Please enter the amount', noErrorTxt: true });
      return;
    } else if (currentAmount === "0.00") {
      setErrorPopUp({ res: 'Entered Amount must be greater than 0', noErrorTxt: true });
      return;
    } else if (currentAmount > props.seat?.paymentCheck?.paymentAmount) {
      setErrorPopUp({
        res: currentAmount === "0.00" ?
          `Entered Amount should be greater than ${currenySymbol}0.00` :
          `Entered Amount cannot be greater than ${currenySymbol}${props?.seat?.paymentCheck?.paymentAmount?.toFixed(2)}`,
        noErrorTxt: true,
      });
    } else {
      setIsAmountEdit({ isOpen: false });
    }
  }, [inputName, setErrorPopUp, currenySymbol, props.seat?.paymentCheck?.paymentAmount]);

  const handleOnChange = useCallback((e) => {
    const newValue = (e / 100).toFixed(2);
    if (!isNaN(newValue) && parseFloat(newValue) > 0) {
      setCreditCardAmount(newValue);
    } else {
      setCreditCardAmount("0.00");
    }
  }, [setCreditCardAmount]);
  
  const handleSetInputEmpty = useCallback(() => {
    setIsAmountEdit((prev) => ({ ...prev, isFirstClick: false }));
    setInputs((prev) => ({ ...prev, [inputName]: "" }));
    handleOnChange("0.00");
    setIsAmountEdit((prev) => ({ ...prev, isError: false }));
  }, [inputName, handleOnChange]);

  const payWithGiftCardDetails = () => {
    const allCards = getAllGiftCards();
    const totalGiftCardAmount = allCards.reduce((sum, card) => sum + (card?.paymentAmount || 0), 0);

    return totalGiftCardAmount >= seat?.paymentCheck?.totalAmount
      ? seat?.paymentCheck?.totalAmount?.toFixed(2)
      : totalGiftCardAmount?.toFixed(2);
  };

  const payButtonLabelText = () => {
    const allCards = getAllGiftCards();
    let amount = "";

    if (
      // !hasGiftCards &&
      !seat?.paymentCheck?.creditCard &&
      !seat?.paymentCheck?.cash &&
      payModeType === DEFAULT
    ) {
      // amount += isCallCenter ? LABEL().CC_SELECT_PAYMENT_METHOD : LABEL().EPS_SELECT_PAYMENT_METHOD;
      amount += isCallCenter
        ? LABEL().CC_SELECT_PAYMENT_METHOD
        : isTogo
          ? LABEL().TG_SELECT_PAYMENT_METHOD
          : LABEL().EPS_SELECT_PAYMENT_METHOD;

    } else if (payModeType === GIFT_CARD) {
      // else if (hasGiftCards || payModeType === GIFT_CARD) {
      const totalGiftCardAmount = allCards.reduce((sum, card) => sum + (card?.paymentAmount || 0), 0);

      if (totalGiftCardAmount > 0) {
        // amount += isCallCenter ? LABEL().CC_SELECT_PAYMENT_METHOD : LABEL().EPS_SELECT_PAYMENT_METHOD;
        amount += isCallCenter
          ? LABEL().CC_SELECT_PAYMENT_METHOD
          : isTogo
            ? LABEL().TG_SELECT_PAYMENT_METHOD
            : LABEL().EPS_SELECT_PAYMENT_METHOD;
      } else if (payModeType === GIFT_CARD) {
        amount += `${LABEL().EPS_PAY_GIFT_CARD} ${currenySymbol}${payWithGiftCardDetails() ? payWithGiftCardDetails() : seat?.paymentCheck?.paymentAmount}`;
      } else {
        amount += `${LABEL().EPS_PAY_GIFT_CARD} ${currenySymbol}0.00`;
      }
    } else if (seat?.paymentCheck?.creditCard || payModeType === CREDIT_CARD) {
      amount += `${LABEL().EPS_PAY_CREDIT_CARD} ${currenySymbol}`;
      if (payModeType === CREDIT_CARD && seat?.paymentCheck?.creditCard) {
        amount += seat?.paymentCheck?.creditCard?.paymentAmount?.toFixed(2);
      } else if (creditCardAmount) {
        amount += Number(creditCardAmount)?.toFixed(2);
      } else {
        amount += "0.00";
      }
    } else if (seat?.paymentCheck?.cash) {
      amount += `${LABEL().EPS_PAY_CASH} ${currenySymbol}`;
      if (seat?.paymentCheck?.cash?.paymentAmount) {
        amount += seat?.paymentCheck?.cash?.paymentAmount?.toFixed(2);
      }
    } else {
      amount += "0.00";
    }
    return amount;
  };

  const onClickBtn = useCallback((e) => {
    setIsAmountEdit((prev) => ({ ...prev, isFirstClick: false }));
    if (e !== "{bin}") {
      const currentInputs = inputsRef.current;
      const newValue = currentInputs[inputName] ? currentInputs[inputName].concat(e) : "".concat(e);
      setInputs({ ...currentInputs, [inputName]: newValue });
      handleOnChange(Number(newValue));
    }
  }, [inputName, handleOnChange]);
  const stationName = seat?.stationName?.length > 8 ? seat?.stationName?.substring(0, 8).concat('...') : seat.stationName || seat.stationNumber;

  const IsAmtToPayHidden = () => {
    return (payModeType === CREDIT_CARD || payModeType === DEFAULT) && !seat?.paymentCheck?.creditCard && !infoDeletion?.isOpen
  }
  const displayStyle = (index) => {
    const cashBtn = deviceInfo?.deviceGroup?.paymentTypes?.cash
    const giftBtn = authInfo?.loyaltyInfo?.supportsGiftCardPayment
    if (cashBtn && giftBtn) {
      if (index === 0) {
        return 'pl-0 pr-1'
      } else if (index === payModeType.length - 1) {
        return 'pl-1 pr-0'
      } else {
        return 'px-1'
      }
    } else if (!cashBtn && !giftBtn) {
      return 'px-0'
    } else {
      if (index === 0) {
        return 'pl-0 pr-1'
      } else {
        return 'pl-1 pr-0'
      }
    }
  }
  // HTML and CSS
  return (
    <div className="col-12 px-0 position-relative">
      {/* 1. back button */}
      {seat?.paymentCheck?.tickets?.length == 0 && (
        <TouchableDiv
          className={cn(
            "position-fixed d-flex justify-content-center align-items-center rounded",
          )}
          style={{
            left: "16px",
            top: "16px",
            zIndex: "999",
            width: "2rem",
            height: "2rem",
            backgroundColor: serverAppTheme.iconcolor_bg_box,
          }}
          onClick={(e) => {
            e.preventDefault();
            if (isTipOnlyEnabled) {
              handleBackForTipOnly();
            } else {
              handleBackButton();
              toggleOtherPaymentOption();
            }
          }}
        >
          <BackChevron
            fill={serverAppTheme?.iconcolor}
            alt=""
          />
        </TouchableDiv>
      )}
      {/* 2. Subtotal section */}
      <div className={cn("col-12 px-0", props?.showCheckSeat() ? 'pt-2' : 'pt-3')}>
        <div
          className={cn(
            "col-12 py-2 px-12 flex-column rounded fs_16 fw-400 position-relative",
          )}
          style={{
            background: serverAppTheme?.selector_control_color,
            color: serverAppTheme?.primary_text,
            height: (isTogo || isCallCenter) ? "8.5rem" : seat?.paymentCheck?.cash?.roundingAmount > 0 ? '10.50rem' : "10.125rem",
          }}
        >
          <div className="col-12 px-0 overflowY h-89">
            {paymentDetails.map((el) => {
              return el.show() && (
                el.key === "Discount" && el.price === 0 ? (
                  <></>
                ) : (
                  <div
                    key={el.key}
                    className={cn("col-12 d-flex px-0",
                      // styles.totalAmount  CSS not present
                    )}
                  >
                    <div className="col-8 px-0 text-left">
                      {el.name}{" "}
                      {el.key === "Tip" &&
                        (authInfo?.tipInfo?.ruleType === 1 ||
                          seat?.paymentCheck?.tipType === 3) && (isTipOnlyEnabled ? '' : 
                        "(" + seat?.paymentCheck?.tipTypeValue + "%)")}
                    </div>
                    <div className="col-4 px-0 text-right">
                      {el.key === "Discount" && '-'}
                      {currenySymbol}
                      {el.price?.toFixed(2)}
                    </div>
                  </div>
                )
              )
            })}
          </div>
          <div
            className={cn(
              "col-12 d-flex pl-0 pr-4 position-absolute", isTipOnlyEnabled ? 'justify-content-between' : ''
            )}
            style={{ bottom: "0" }}
          >
            <div className={cn('text-left fw-600 fs_20 px-0 col-3')}>Total</div>
            {!isTipOnlyEnabled && (
              <div className="col-6 fw-400 text-underline" style={{ fontSize: '1.25rem', color: serverAppTheme?.NO_RECEIPT }}>
                <TouchableDiv
                  className="d-flex justify-content-center align-items-center fs_16 pt-1"
                  tabIndex="0"
                  role="button"
                  onClick={() => {
                    setViewDetailsOpen(true);
                  }}
                >
                  {LABEL().EPS_ITEMIZED_CHECK}
                </TouchableDiv>
              </div>
            )}
            <div className={cn('px-0  fs_20 fw-600 text-right col-3')}>
              {currenySymbol}
              {Number(
                seat?.paymentCheck?.totalAmount +
                  seat?.paymentCheck?.tipAmount +
                  (seat?.paymentCheck?.cash?.roundingAmount > 0
                    ? seat?.paymentCheck?.cash?.roundingAmount
                    : 0) || 0
              )?.toFixed(2)}
            </div>
          </div>
        </div>
      </div>
      {/* 3. Payments, Total Paid, Amount Due */}
      <div className={cn("col-12 px-0")}>
        <div
          className={cn("fs_20 fw-600 pt-2 pb-1")}
          style={{
            color: serverAppTheme?.primary_text,
          }}
        >
          Payments
        </div>
        <div
          className={cn("col-12 py-2 px-12 rounded fs_16 fw-400 overflowY")}
          style={{
            background: serverAppTheme?.selector_control_color,
            color: serverAppTheme?.primary_text,
            height: props?.showCheckSeat() ? "4.315rem" : "5.6875rem",
          }}
        >
          {seat?.paymentCheck?.tickets?.length > 0 ? seat?.paymentCheck?.tickets?.map((e, index) => {
            return (
              <div className="col-12 d-flex px-0" key={index}>
                {e.paymentTypeName === "Gift Card" ? (
                  <>
                    <div className="col-4 px-0 text-left">
                      {e.paymentTypeName}
                    </div>
                    <div className="col-4 px-0 text-center">
                      {formatRedactedCardNumber(e.redactedCardNumber || e.cardNumber)}
                    </div>
                    <div className="col-4 px-0 text-right">
                      {currenySymbol}
                      {Number(e.ticketAmount || 0)?.toFixed(2)}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-6 px-0 text-left">
                      {e.paymentTypeName === "Credit card"
                        ? `${e.paymentTypeName}(
                        ${e.cardType}${e.redactedCardNumber},
                      )`
                        : e.paymentTypeName}
                    </div>
                    <div className="col-6 px-0 text-right">
                      {currenySymbol}
                      {Number(e.ticketAmount || 0)?.toFixed(2)}
                    </div>
                  </>
                )}
              </div>
            )
          }) : (
            <div className="h-100 col-12 d-flex px-0 fs_20 justify-content-center align-items-center">
              {LABEL().EPS_NO_PAYEMNTS}
            </div>
          )}
        </div>
        <div
          className="col-12 px-0 d-flex pt-2 fs_20 fw-600"
          style={{
            color: serverAppTheme?.primary_text,
          }}
        >
          <div className="col-8 text-left px-0">Total Paid</div>
          <div className="col-4 px-0 text-right">
            {currenySymbol}
            {seat?.paymentCheck?.totalCollectedAmount?.toFixed(2)}
          </div>
        </div>
        <div
          className="col-12 px-0 d-flex pt-2 fs_20 fw-600"
          style={{
            color: serverAppTheme?.primary_text,
          }}
        >
          <div className="col-8 px-0 text-left">Amount Due</div>
          <div className="col-4 px-0 text-right">
            {currenySymbol}
            {seat?.paymentCheck?.paymentAmount?.toFixed(2)}
          </div>
        </div>
      </div>
      {/* 4. Amount to pay, button => credit, gift and cash */}
      <div className={cn("col-12 p-0")}>
        <div>
          <div
            className={cn("col-12 p-0 d-flex py-12 align-items-center")}
            style={{ color: serverAppTheme?.primary_text }}
          >
            <div className="col-7 d-flex p-0">
              <div
                className={cn(
                  "p-0 fs_20 fw-600 d-flex align-items-center",
                )}
                style={{
                  color: IsAmtToPayHidden()
                    ? serverAppTheme?.primary_text
                    : serverAppTheme?.btn_font_color_disabled,
                }}
              >
                {LABEL().EPS_PAY}
              </div>

              {IsAmtToPayHidden() && (
                <TouchableDiv
                  className={cn(
                    "ml-2 d-flex justify-content-center align-items-center rounded",
                  )}
                  style={{
                    zIndex: "999",
                    width: "2.75rem",
                    height: "2.75rem",
                    backgroundColor: serverAppTheme.iconcolor_bg_box,
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    setCreditCardAmount(
                      String(Number(seat?.paymentCheck?.paymentAmount)?.toFixed(2)),
                    );
                    setInputs({ [inputName]: "" });
                  }}
                >
                  <EipsRedo fill={serverAppTheme?.iconcolor} alt="" />
                </TouchableDiv>
              )}
            </div>

            <div
              className={cn(
                "p-0 d-flex align-items-center",
                IsAmtToPayHidden() ? "col-5 ml-1" : "col-5",
              )}
              style={{
                height: "2.75rem",
                border: "none",
                background: (isCallCenter || isTogo) ? '#b1b1b1' : IsAmtToPayHidden()
                  ? serverAppTheme?.inputBg
                  : serverAppTheme?.checkDetail_tabs,
                borderBottom:
                  IsAmtToPayHidden() && serverAppTheme?.inputBorder_Bottom,
                color: IsAmtToPayHidden()
                  ? serverAppTheme?.primary_text
                  : serverAppTheme?.btn_font_color_disabled,
                borderRadius: "0",
              }}
            >
              <div
                className={cn(
                  "fs_20 fw-600 text-right",
                  IsAmtToPayHidden() ? "col-9 mr-1 pr-0" : "col-12",
                )}
              >
                {LABEL().CURRENCY_SYMBOL}{" "}
                {creditCardAmount ? Number(creditCardAmount)?.toFixed(2) : "0.00"}
              </div>
              {IsAmtToPayHidden() && (
                <TouchableDiv
                  className={cn(
                    "d-flex justify-content-center align-items-center rounded m-auto",
                  )}
                  style={{
                    zIndex: "999",
                    width: "2rem",
                    height: "2rem",
                    backgroundColor: (isCallCenter || isTogo) ? '#b1b1b1' : serverAppTheme.iconcolor_bg_box,
                  }}
                  onClick={(event) => {
                    event.preventDefault();
                    setIsAmountEdit((prev) => ({
                      ...prev,
                      isOpen: true,
                      isFirstClick: true,
                    }));
                    setInputName("editCreditCardAmount");
                    setInputs({ editCreditCardAmount: "" });
                  }}
                  disabled={isCallCenter || isTogo}
                >
                  <EipsEdit fill={serverAppTheme?.iconcolor} alt="" />
                </TouchableDiv>
              )}
            </div>
          </div>
        </div>
        <div
          className="w-100"
          style={{
            color: "",
            background: serverAppTheme?.strokeLine,
            height: "1px",
          }}
        />
        <div
          className={cn(
            "text-center fw-500 fs_20",
            props?.showCheckSeat() ? "py-2" : (isDriveThru || isCounter || isCallCenter || isTogo || speedOrderMode) ? "pt-2 pb-2" : "pt-3 pb-12",
          )}
          style={{ color: serverAppTheme?.btn_font_color_disabled, opacity: 1, height: !(isDriveThru || isCounter || isCallCenter || isTogo || speedOrderMode) && "3.5rem", }}
        >
          <div style={{ height: (isDriveThru || isCounter) ? "4.25rem" : (isTogo ? "10.7rem" : speedOrderMode ? "4.5rem" : isCallCenter ? "8.25rem" : "0rem") }}>
            {(isDriveThru || isCounter || speedOrderMode) && isPayAtCounter && (
              <TouchableButton
                className={cn("p-0 rounded fw-600 fs_20 col-12 border-0 od-secondary-btn-font-color od-secondary-btn-bg-color",)}
                style={{
                  backgroundColor: serverAppTheme?.primaryBtn,
                  color: serverAppTheme?.btn_font_color,
                  height: "4.25rem",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setIsPayAtCounterPopUp(true);
                }}
                rippleEffect={true}
              >
                {(isDriveThru || isCounter) ? LABEL().EPS_PAY_AT_COUNTER : speedOrderMode ? LABEL().SPO_KEEP_IT_OPEN : ''}
              </TouchableButton>
            )}
            {isTogo && (
              <TouchableButton
                className={cn("p-0 rounded fw-600 fs_20 col-12 border-0 od-secondary-btn-font-color od-secondary-btn-bg-color",  isTogo ? 'mb-2' : "")}
                style={{
                  backgroundColor: serverAppTheme?.primaryBtn,
                  color: serverAppTheme?.btn_font_color,
                  height: isTogo ? "3.5rem" : "4.25rem",
                }}
                onClick={(e) => {
                  e.preventDefault();
                 setSendOrderConfirmation({isOpen:true,type:'payLater'});
                }}
                rippleEffect={true}
              >
                {LABEL().TG_PAY_LATER}
              </TouchableButton>
            )}
            {(isCallCenter || isTogo) && (
              <TouchableButton
                className={cn("p-0 rounded fw-600 fs_20 col-12 border-0 od-secondary-btn-font-color od-secondary-btn-bg-color", isCallCenter || isTogo ? 'mb-2' : '')}
                style={{
                  backgroundColor: serverAppTheme?.primaryBtn,
                  color: serverAppTheme?.btn_font_color,
                  height: isTogo ? "3.5rem" : "4.25rem",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setSendOrderConfirmation({isOpen:true,type:'orderAtRes'});
                }}
                rippleEffect={true}
              >
                {isTogo ? LABEL().TG_SEND_AND_PAY_AT_RESTAURANT : LABEL().CC_SEND_AND_PAY_AT_RESTAURANT}
              </TouchableButton>
            )}

            {(isCallCenter || isTogo) &&
              <div
                className={cn(
                  "justify-content-center align-items-center col-12 d-flex px-0",
                )}>
                <TouchableButton
                  className={cn("p-0 rounded fw-600 fs_20 col-12 border-0 od-secondary-btn-font-color od-secondary-btn-bg-color", isCallCenter || isTogo ? 'pb-2' : '')}
                  style={{
                    backgroundColor: serverAppTheme?.primaryBtn,
                    color: serverAppTheme?.btn_font_color,
                    height: isTogo ? "3.5rem" : "4.25rem",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    setSendOrderConfirmation({ isOpen: true, type: 'textToPay' });
                  }}
                  rippleEffect={true}
                >
                  {isTogo ? LABEL().TG_TEXT_TO_PAY : LABEL().CC_TEXT_TO_PAY}
                </TouchableButton>
              </div>}
          </div>

        </div>

        <div
          className={cn(
            "justify-content-center align-items-center col-12 d-flex px-0", (isDriveThru || isCounter || speedOrderMode) ? 'pb-2' : 'pb-12'
          )}
          style={{
            bottom: speedOrderMode ? "0.3rem" :
              !(isDriveThru || isCounter)
                ? "1.3rem"
                : isPayAtCounter
                  ? "0"
                  : "2.5rem",
          }}
        >
          {visiblePaymentModes.map((item, index) => {
            const isButtonEnabled = !payModeType || item.key === payModeType;
            const isDisabled =
              isZeroAmountDue ||
              !isButtonEnabled ||
              (item.key === GIFT_CARD && !authInfo?.loyaltyInfo?.supportsGiftCardPayment) ||
              disablePaymentModes(item.key);

            return (
              <div
                key={item.key}
                className={cn(
                  colClass,
                  "align-items-center d-flex justify-content-center rounded",
                  displayStyle(index)
                )}
              >
                <TouchableButton
                  className={cn(
                    "p-0 rounded fw-600 fs_20 col-12 border-0",
                    !isDisabled
                      ? "od-secondary-btn-font-color od-secondary-btn-bg-color"
                      : "od-disable-btn-bg-color od-disable-btn-font-color"
                  )}
                  style={{
                    backgroundColor: !isDisabled
                      ? serverAppTheme?.primaryBtn
                      : serverAppTheme?.secondaryBtnDisabled,
                    color: serverAppTheme?.btn_font_color,
                    height: "4.25rem",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    if (isDisabled) return;
                    handleAllPayment(item.key);
                  }}
                  disabled={isDisabled}
                  rippleEffect={true}
                >
                  {item.name}
                </TouchableButton>
              </div>
            );
          })}

        </div>

      </div>
      {/* 5. button => Select Payment Method */}
      <TouchableButton
        className={cn(
          "btnNewUI rounded btn-ripple btn68 w-100 position-absolute", (payModeType === GIFT_CARD && isGiftCardZero) ||
            payModeType === DEFAULT ? "od-disable-btn-bg-color od-disable-btn-font-color" : " od-primary-btn-bg-color od-primary-btn-font-color"
        )}
        style={{
          background:
            (payModeType === GIFT_CARD && isGiftCardZero) ||
              payModeType === DEFAULT
              ? serverAppTheme?.secondaryBtnDisabled
              : serverAppTheme?.secondaryBtn,
          color:
            (payModeType === GIFT_CARD && isGiftCardZero) ||
              payModeType === DEFAULT
              ? "#636363"
              : serverAppTheme?.btn_font_color,
          bottom: "0",
          transform: (isDriveThru || isCounter) ? "translateY(0)" : "translateY(8px)",
        }}
        disabled={
          (payModeType === GIFT_CARD && isGiftCardZero) ||
          payModeType === DEFAULT
        }
        onClick={() => handlePayment()}
        rippleEffect={true}
      >
        {payButtonLabelText()}
      </TouchableButton>
      {/* 6. paymode type */}
      <div
        className="w-100 rounded p-2"
        style={{
          height: (isDriveThru || isCounter || isCallCenter) ? "7.7rem" : (isTogo ? "7.3rem" : speedOrderMode ? "8rem" : "9rem"),
          backgroundColor: serverAppTheme?.stage_tab_button_selected,
          border: serverAppTheme?.offers_Border,
        }}
      >
        {(payModeType === CREDIT_CARD) && seat?.paymentCheck?.creditCard && (
          <div className={cn('col-12 h-100', (isDriveThru || isCounter) ? 'px-2' : 'px-12 py-2 ')}>
            <div className='col-12 px-0 h-100'>
              <div className='col-12 px-0 d-flex'>
                <div className='col-10 px-0 fs_20'>{LABEL().EPS_CREDIT_CARD_PAYMENT}</div>
                <TouchableDiv
                  className='col-2 px-0 d-flex align-items-center justify-content-end'
                  tabIndex="0"
                  role="button"
                  onClick={() => { handleCreditCardDeleteBalance(); setPayModeType(DEFAULT); setInputs({ "editCreditCardAmount": "" }) }}
                >
                  <div
                    className={cn(
                      "rounded d-flex justify-content-center align-items-center",
                      styles.DeletBoxDimension,
                    )}
                    style={{
                      backgroundColor:
                        serverAppTheme?.mod_group_name_bg,
                      border: serverAppTheme?.select_border,
                    }}
                  >
                    <Delete
                      width={"60%"}
                      height={"60%"}
                      fill={serverAppTheme?.iconcolor}
                    />
                  </div>
                </TouchableDiv>
              </div>
              <div className='col-12 px-0 d-flex pt-2 fs_16'>
                <div className='col-6 px-0 text-left'>{LABEL().EPS_PAY}</div>
                <div className='col-6 px-0 text-right'>{currenySymbol}{Number(seat?.paymentCheck?.creditCard?.paymentAmount || 0)?.toFixed(2)}</div>
              </div>
            </div>
          </div>
        )}
        {(payModeType === CASH) && seat?.paymentCheck?.cash && (
          <div className={cn('col-12 h-100', (isDriveThru || isCounter) ? 'px-2' : 'px-12 py-2')}>
            <div className='col-12 px-0 h-100'>
              <div className='col-12 px-0 d-flex'>
                <div className='col-10 px-0 fs_20 d-flex align-items-center'>{LABEL().EPS_CASH}</div>
                <TouchableDiv
                  className='col-2 px-0 d-flex align-items-center justify-content-end'
                  tabIndex="0"
                  role="button"
                  onClick={() => { handleCashClearBalance(); setPayModeType(DEFAULT); }}
                >
                  <div
                    className={cn(
                      "rounded d-flex justify-content-center align-items-center",
                      styles.DeletBoxDimension,
                    )}
                    style={{
                      backgroundColor:
                        serverAppTheme?.mod_group_name_bg,
                      border: serverAppTheme?.select_border,
                    }}
                  >
                    <Delete
                      width={"60%"}
                      height={"60%"}
                      fill={serverAppTheme?.iconcolor}
                    />
                  </div>
                </TouchableDiv>
              </div>
              <div className='col-12 px-0 d-flex pt-2 fs_16'>
                <div className='col-6 px-0 text-left'>{LABEL().EPS_COLLECTED}</div>
                <div className='col-6 px-0 text-right'>{currenySymbol}{Number(seat?.paymentCheck?.cash?.paymentAmount)?.toFixed(2)}</div>
              </div>
              <div className='col-12 px-0 d-flex pt-2 fs_16'>
                <div className='col-6 px-0 text-left'>{LABEL().EPS_CHANGE}</div>
                <div className='col-6 px-0 text-right'>{currenySymbol}{Number(seat?.paymentCheck?.cash?.changeAmount)?.toFixed(2)}</div>
              </div>
            </div>
          </div>
        )}
        {!getGiftCard() && !seat?.paymentCheck?.creditCard && !seat?.paymentCheck?.cash && payModeType === DEFAULT && (
          <div className="col-12 h-100 d-flex align-items-center justify-content-center fs_20">
            {LABEL().EPS_SELECT_A_PAYMENT_METHOD}
          </div>
        )}
      </div>
      {/* 7. Amount edit popup */}
      <FullWithModal
        isOpen={isAmountEdit?.isOpen}
        isModalCenter
        customClass2={cn("w-100 h-100")}
        noBackground
        style={AmountPopUpStyle.amountPopUp}
      >

        <div className="col-12">
          <div className={cn('col-12 fw-600 fs_18 d-flex pt-3 p-0')}>
            <div className={cn('fs_18 fw-600 col-6 p-0')}>{props.seat?.tab ? 'Tab' : 'Table'}  {stationName}</div>
            <div className={cn('fs_18 fw-600 col-6 p-0 text-right')}># {props?.seat?.number}</div>
          </div>
          <div className="h-30 d-flex justify-content-center align-items-center mb-3">
            <div
              className="mt-2 fs_32 fw-600"
              style={{ color: serverAppTheme?.primary_text }}
            >
              {CUSTOM_MESSAGES().AMOUNT_TO_PAY}
            </div>
          </div>
          <div
            className={cn("col-12 d-flex align-items-center px-2")}
            style={{
              height: "4rem",
              border: "none",
              background: serverAppTheme?.inputBg,
              borderBottom: serverAppTheme?.inputBorder_Bottom,
              color: serverAppTheme?.primary_text,
              borderRadius: "0",
            }}
          >
            <div className={cn("fs_32", isAmountEdit?.isFirstClick ? '' : 'fw-600')} style={{ color: isAmountEdit?.isFirstClick && '#787878' }}>
              {isAmountEdit?.isFirstClick ? "Enter amount" : creditCardAmount}
            </div>
            {!isAmountEdit?.isFirstClick && (
              <TouchableDiv
                className={cn(
                  styles.crossIconInInputField,
                  "h-100 d-flex align-items-center",
                )}
                tabIndex="0"
                role="button"
                onClick={(e) => {
                  e.preventDefault();
                  setInputs({ [inputName]: "" });
                  setCreditCardAmount(String(`0.00`));
                  setIsAmountEdit((prev) => ({ ...prev, isError: false }));
                }}
              >
                <Cross fill={serverAppTheme?.iconcolor} />
              </TouchableDiv>
            )}
          </div>
          {/* <div
            className="fw-400 fs_12 text-right pt-2"
            style={{ color: "#EB5252", height: "2.375rem" }}
          >
            {isAmountEdit?.isError &&
              (creditCardAmount === "0.00"
                ? `Entered Amount should be greater than ${currenySymbol}0.00`
                : `Entered Amount cannot be greater than ${currenySymbol}${props?.seat?.paymentCheck?.paymentAmount?.toFixed(2)}`)}
          </div> */}
          <div className="position-relative">
            <Keyboard
              onClickBtn={onClickBtn}
              type="numeric"
              isClr={true}
              closeKeyboard={closeKeyboard}
              maxLength={100}
              customClass={cn(
                "fs-30 position-absolute h-auto pt-2 pb-3 px-2",
              )}
              serverAppTheme={serverAppTheme}
              setinputEmpty={handleSetInputEmpty}
            />
          </div>
          <div className="row">
            <div
              className={cn(
                "position-absolute d-flex col-12",
              )}
              style={{ bottom: "1rem" }}
            >
              <TouchableButton
                className={cn(
                  "btn-ripple fs_28 fw-600 mr-2 col w-100 p-0 od-cancel-btn-bg-color  od-cancel-btn-font-color od-cancel-btn-st-color",
                  styles.primaryBtnStyle,
                )}
                style={{
                  fontFamily: "Poppins",
                  borderRadius: "4px",
                  border: "1px solid #2541A4",
                  height: "7.7vh",
                  backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                  color: serverAppTheme?.primary_text,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setIsAmountEdit({
                    isOpen: false,
                    isError: false,
                    isFirstClick: true,
                  });
                  setInputs({ [inputName]: "" });
                  setCreditCardAmount(String(Number(seat?.paymentCheck?.paymentAmount || 0)?.toFixed(2)));
                }}
                rippleEffect={true}
              >
                {LABEL().EPS_CANCEL}
              </TouchableButton>
              <TouchableButton
                className={cn("btn-ripple fs_28 fw-600 col w-100 p-0  od-primary-btn-bg-color od-primary-btn-font-color", styles.primaryBtnStyle)}
                style={{
                  fontFamily: "Poppins",
                  borderRadius: "4px",
                  border: "none",
                  height: "7.7vh",
                  background: serverAppTheme?.secondaryBtn,
                  color: serverAppTheme?.btn_font_color,
                }}
                onClick={(e) => { e.preventDefault(); closeKeyboard(); }}
                rippleEffect={true}
              >
                {LABEL().EPS_APPLY}
              </TouchableButton>
            </div>
          </div>
        </div>
      </FullWithModal>
      {isPayAtCounterPopUp && (
        <Modal
          isOpen={isPayAtCounterPopUp}
          customClass="p-4"
          customClass2="d-flex justify-content-center align-items-center"
          customClass3={cn(styles.paycounterPopupH)}
          isModalCenter
        >
          <div
            className={'col-12 row mx-0 justify-content-center p-4 align-items-center position-relative text-center'}
            style={{
              backgroundColor: serverAppTheme?.popUp_bg,
              color: serverAppTheme?.primary_text,
              fontFamily: 'Poppins',
              border: serverAppTheme?.popupBorder,
              borderRadius: '16px',
              boxShadow: serverAppTheme?.popUp_box_shadow,
            }}
          >
            <div className="col-12 fw-400">
              <div className="text-center justify-content-center pb-25 mb-15">
                <div
                  className={cn('fs_18 pb-10')}
                >
                  {CUSTOM_MESSAGES().SEND_ORDER_COLLECT_PAYMENT_AT_COUNTER}
                </div>
              </div>
            </div>
            <div
              className={cn(
                'col-12 d-flex justify-content-center position-absolute p-4',
              )}
              style={{ bottom: '0' }}
            >
              <div className="col-6 pr-1 pl-0">
                <TouchableButton
                  type="submit"
                  className={cn(
                    'col-12 btn44 od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color'
                  )}
                  style={{
                    backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                    color: serverAppTheme?.primary_text,
                    border: '1px solid #2541A4',
                  }}
                  onClick={e => {
                    setIsPayAtCounterPopUp(false);
                    e.preventDefault();
                  }}
                  rippleEffect={true}
                >
                  <div className={cn('fs_24')}>
                    {LABEL().TIP_NO}
                  </div>
                </TouchableButton>
              </div>
              <div className="col-6 pl-1 pr-0">
                <TouchableButton
                  type="submit"
                  className={cn(
                    'col-12 btn-ripple btn-lg btn44 od-primary-btn-bg-color od-primary-btn-font-color'
                  )}
                  style={{
                    background: serverAppTheme?.secondaryBtn,
                    color: serverAppTheme?.btn_font_color,
                  }}
                  onClick={e => {
                    handlePayAtCounterPayment();
                    setIsPayAtCounterPopUp(false);
                    e.preventDefault();
                  }}
                  rippleEffect={true}
                >
                  <div className={cn('fs_24')}>
                    {LABEL().TIP_YES}
                  </div>
                </TouchableButton>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default EmployeeInitiatedPaymentScreen;
